import { createSlice } from "@reduxjs/toolkit";
import { getAllUser } from "../../reduxThunk/thunkAllUser/AllUser";

const initialState = {
  AllUser: [],
  loading: false,
  error: null,
  success: false,
};

const allUserSlice = createSlice({
  name: "authuser",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(getAllUser.fulfilled, (state, action) => {
        state.loading = false;
        state.AllUser = action.payload;
        state.success = true;
      })
      .addCase(getAllUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "failed to logout user";
        state.success = false;
      });
  },
});

export default allUserSlice.reducer;
